export default __webpack_public_path__ + "static/media/check-mark-gray.e94caebd.svg";